import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import City from '../../../../assets/images/city.svg';
import { MdFilterList } from 'react-icons/md';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionTwoProps {
  section: OnboardingSummary;
}

const SectionTwo = ({ section }: SectionTwoProps) => {
  const { stagePreference, industryFocusAreas } = useOnboardingSummary({
    section,
  }) as { stagePreference: string[]; industryFocusAreas: string[] };

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>
        Finding investment opportunities (as a VC, angel, etc.)
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <MdFilterList size={24} className='text-secondary-500' />
            Stage Preference:
          </div>
          <div className='flex flex-wrap gap-4'>{stagePreference}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={City} alt='Crown' />{' '}
            Industry Focus Areas:
          </div>
          <div className='flex flex-wrap gap-4'>{industryFocusAreas}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
